import moment from 'moment';
import { ConfigHelper } from 'services/charting';

export default class ThingDetailsController {
    /** @ngInject */
    constructor(
        EventEmitter,
        Loader,
        $q,
        LabelsApi,
        ThingsApi,
        $scope,
        ToastService,
        TranslationService
    ) {
        this.eventEmitter = EventEmitter;
        this.Loader = Loader;
        this.$q = $q;
        this.LabelsApi = LabelsApi;
        this.ThingsApi = ThingsApi;
        this.evtSource = null;
        this.$scope = $scope;
        this.ToastService = ToastService;
        this.TranslationService = TranslationService;

        this.performHealthCheck = this.performHealthCheck.bind(this);
        this.onUpdateReceived = this.onUpdateReceived.bind(this);
    }

    get isUpdatedLongAgo() {
        if (!this.thing.state || !this.thing.state.updated) {
            return true;
        }
        return moment(this.thing.state.updated).isBefore(moment().subtract(1, 'day'));
    }

    $onInit() {
        this.alerts = [];
        this.history = [];
        this.events = [];
        this.owner = {};
        this.users = [];

        this.editMode = false;

        this.subscribeToLiveUpdates();

        this.chartType = this.thing.getHistoryChartType();
        this.showChart = false;

        this.loadHistoricalData();

        this.$scope.$on('health-checker-page-visible', this.performHealthCheck);
        this.$scope.$on('health-checker-network-up', this.performHealthCheck);
    }

    $onDestroy() {
        this.unsubscribeFromLiveUpdates();
    }

    $onChanges(changes) {
        if (changes.thingUpdate && !changes.thingUpdate.isFirstChange()) {
            this.thing.starred = changes.thingUpdate.currentValue.starred;
        }
    }

    loadThingState() {
        this.ThingsApi.entity(this.thing.id)
            .then((thing) => {
                Object.assign(this.thing.state, thing.state);
            });
    }

    performHealthCheck() {
        if (this.liveDataSubscription && !this.liveDataSubscription.isAlive) {
            this.loadThingState();
        }
    }

    onUpdateReceived(thingId, patch) {
        if (patch.state) {
            if (!patch.state.properties.touch) {
                patch.state.properties.last_pressed = this.thing.state.properties.last_pressed;
            }
            Object.assign(this.thing.state.properties, patch.state.properties);
            this.thing.state.updated = patch.state.updated;
        } else {
            Object.assign(this.thing, patch);
        }
        if (patch.state) {
            this.loadHistoricalData();
        }
        this.$scope.$applyAsync();
    }

    unsubscribeFromLiveUpdates() {
        if (this.liveDataSubscription) {
            this.liveDataSubscription.stop();
        }
    }

    subscribeToLiveUpdates() {
        this.unsubscribeFromLiveUpdates();

        this.liveDataSubscription = this.ThingsApi.subscribeToThingUpdates(
            this.thing.id,
            this.onUpdateReceived
        );
    }

    loadHistoricalData() {
        let historyPromise;

        const { start, end } = ConfigHelper.getDefaultTimespan();

        const timePeriod = {
            start: start.format(),
            end: end.format()
        };

        if (this.thing.isHistoryAggregated()) {
            historyPromise = this.ThingsApi.historicalQueryAggregated(this.thing.id, {
                fields: this.thing.getHistoryFieldsConfig(),
                interval: this.thing.getDefaultHistoryInterval(),
                time_period: timePeriod,
                fill: 'null'
            });
        } else {
            historyPromise = this.ThingsApi.historicalQuery(this.thing.id, {
                fields: this.thing.getHistoryFieldsConfig(),
                time_period: timePeriod
            });
        }

        historyPromise.then((data) => {
            this.history = data;
            this.showChart = true;
        });
    }

    onChangeThingStarred({ starred }) {
        this.thing.starred = starred;
        this.onThingUpdated(
            this.eventEmitter({
                thing: this.thing
            })
        );
    }

    processLabel({ data }) {
        this.Loader.show();
        return this.LabelsApi
            .create(data)
            .finally(() => {
                this.Loader.hide();
            });
    }

    updateThing({ patch, data }) {
        this.Loader.show();
        return this.ThingsApi
            .update(this.thing.id, patch)
            .then(() => {
                Object.assign(this.thing, data || patch);

                this.ToastService.showSimpleTranslated('thing_was_saved');

                this.onThingUpdated(
                    this.eventEmitter({
                        thing: this.thing
                    })
                );
            })
            .catch(({ data: response }) => {
                this.ToastService.showSimpleText(
                    (response && response.Error) ?
                        response.Error :
                        this.TranslationService.getLine('thing_wasnt_saved')
                );
            })
            .finally(() => {
                this.Loader.hide();
            });
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-details.controller.js